/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SummarizeChatResult = {
  /**
   * True when an existing summary was returned without regenerating
   */
  cached: boolean;
  /**
   * The session summary text
   */
  summary: string;
  /**
   * When the summary was last generated.
   */
  summaryGeneratedAt: Date;
};

/** @internal */
export const SummarizeChatResult$inboundSchema: z.ZodMiniType<
  SummarizeChatResult,
  unknown
> = z.pipe(
  z.object({
    cached: z.boolean(),
    summary: z.string(),
    summary_generated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "summary_generated_at": "summaryGeneratedAt",
    });
  }),
);

export function summarizeChatResultFromJSON(
  jsonString: string,
): SafeParseResult<SummarizeChatResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SummarizeChatResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SummarizeChatResult' from JSON`,
  );
}
